module.exports = __webpack_public_path__ + "media/assets/images/blog/QR_CODE_RICHIEDI_DEMO-small-25b8cb463a8bf2dea390c5c3666f60aa.png";